import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable, ReplaySubject } from 'rxjs';
import { LicenseService } from 'app/core/services/license.service';
import { timer } from 'rxjs/observable/timer';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestService } from 'app/core/services/request.service';
import { ScormCloudService } from 'app/core/services/scorm-cloud.service';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { MaterialConfigurationService } from 'app/core/components/workflow-new/material/configurations/material-configuration.service';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';

@Component({
  selector: 'itpx-deliverable-tile-state-container',
  templateUrl: './deliverable-tile-state-container.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliverableTileStateContainerComponent extends RxComponent implements OnInit {
  private tileClicked$ = new Subject<void>();
  @Input() props: any;
  @Input() sharedProfile$: Observable<any>;
  @Input() status$: Observable<any>;
  private conf: MaterialConfiguration;
  private tagType: string;
  private clickable: boolean;
  private state$ = new ReplaySubject<{status: string}>(1);
  private stop$ = new Subject<void>();
  private downloadLink: string;
  protected deliverableStatus: any = {};
  // protected status: string = 'loading';
  protected target: Array<any> = [];
  protected messages: any = {};

  constructor(
    private materialConfiguration: MaterialConfigurationService,
    private licenseService: LicenseService,
    private router: Router,
    private route: ActivatedRoute,
    private requestService: RequestService,
    private scormCloudService: ScormCloudService,
  ) {
    super();
  }

  ngOnInit() {
    this.downloadLink = this.props.googleEmbedLink;
    this.conf = this.materialConfiguration.getConf(this.props);
    Object.assign(this, this.conf);
    const sourceState$ = new ReplaySubject<any>(1);
    this.status$.startWith({id: this.props.id, status: this.props.status})
    // .do(val => console.log(val))
    .filter(val => val.id === this.props.id)
    // .withLatestFrom(Observable.of(this.props))
    // .do(val => console.log(val))
    .bindToLifecycle(this)
    .subscribe(res => { 
      let details = this.props;
      details.status = res.status; 
      sourceState$.next(details); 
      this.state$.next(details);
    });
    const upToDateState$ = sourceState$.filter(val => this.isUpToDate(val.status));
    const inProgressState$ = sourceState$.filter(val => this.productLoading(val.status))
      .switchMap(_ => this.licenseService.checkStatus(this.props.id)).takeUntil(this.stop$);
    const remainingStates$ = sourceState$
      .filter(val => this.isInvalid(val.status));
    const combined$ = Observable.merge(upToDateState$, inProgressState$, remainingStates$).shareReplay(1);
    combined$
      .filter(res => this.isOnlineMaterial(res.type) && this.isUpToDate(res.status))
      .subscribe(res => this.update(res, true));
      combined$
      .filter(res => this.isExternalMaterial(res.type) && this.isUpToDate(res.status))
      .subscribe(res => this.updateExternal(res));
    combined$.bindToLifecycle(this).subscribe(val => {
      if (this.isUpToDate(val.status)) {
        this.clickable = true;
        this.downloadLink = val.googleEmbedLink;
      }
      if (!this.productLoading(val.status))
        this.stop$.next();
      this.state$.next(val);
    }, _ => this.state$.next({status: 'invalid'}));
  }

  updateExternal(res: any): void {
    this.conf.action = LinkActions.SSO;
  }

  isExternalMaterial(type: string): boolean {
    return type === 'externalLink';
  }

  isOnlineMaterial(type: string): boolean {
    return type === 'scormcloud' || type === 'scorm' || type === 'video' || type === 'googleslides';
  }

  isUpToDate(status) {
    return status.toLowerCase() === 'uptodate';
  }

  isInvalid(status) {
    return status.toLowerCase() === 'invalid';
  }

  productLoading(status): boolean {
    return status.toLowerCase() === 'inprogress' || status.toLowerCase() === 'queued';
  }

  update(deliverable: any, createTarget: boolean) {
    //TODO: name can be null ???
    // this.name = deliverable.name || 'Learning Material';
    if (createTarget && deliverable.type === 'scormcloud') {
      this.conf.target = [deliverable.type, deliverable.registrationId, deliverable.scormCloudTokenId];
    } else if (createTarget) {
      this.conf.target = [deliverable.type, deliverable.id];
    }
    this.conf.action = LinkActions.REDIRECT;
    this.conf.links[0].url = this.conf.target;
  }

  error() {
    /*console.log('Throwing error')*/
    this.deliverableStatus.message = 'Error importing course';
    this.deliverableStatus.progress = 0;
    // this.status = 'error';
  }
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/deliverable-state-container/deliverable-tile-state-container.component.ts